export const getFormDropdownOptions = context => {
    const forms = [];
    const formIds = new Set();
    context.pages.forEach(page => {
        if (page?.formDataGenyId &&
            page.type === 'page' &&
            !page.formId?.includes('carouselgroup') &&
            !formIds.has(page.formDataGenyId)) {
            forms.push([page.formName, page.formDataGenyId]);
            formIds.add(page.formDataGenyId);
        }
    });
    return forms;
};